import { createContext, useContext, type ReactNode } from 'react';

type ZIndexContextType = {
  zIndex: number;
};

const ZIndexContext = createContext<ZIndexContextType | undefined>(undefined);

export function ZIndexProvider({ children, zIndex }: { children: ReactNode; zIndex: number }) {
  return <ZIndexContext.Provider value={{ zIndex }}>{children}</ZIndexContext.Provider>;
}

export function useAwareZindex(): number {
  const context = useContext(ZIndexContext);
  return context?.zIndex ?? 0;
}
